import { render, staticRenderFns } from "./CloseRemind.vue?vue&type=template&id=4e29651c&scoped=true&"
import script from "./CloseRemind.vue?vue&type=script&lang=js&"
export * from "./CloseRemind.vue?vue&type=script&lang=js&"
import style0 from "./CloseRemind.vue?vue&type=style&index=0&id=4e29651c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e29651c",
  null
  
)

export default component.exports